export const TITLE = "Euler Electric Auto Price in India 2026 | Euler ev Price";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Euler 3 wheeler price in India starts at ₹3.10–₹9.35 Lakh. Explore Euler Motors EV specs, range, images, reviews & on-road electric auto prices for all models.",
  },
  {
    name: "keywords",
    content:
      "Euler electric auto, Euler 3 wheeler, Euler electric vehicles, Euler three wheeler, Euler electric auto price, Euler commercial vehicles, Euler EV auto, Euler electric truck, Euler HiLoad, Euler HiLoad PV, Euler HiLoad DV, Euler price in India, Euler dealers, Euler specifications, Euler features, Euler battery capacity, Euler range, Euler charging, Euler EMI, Euler financing, Euler test drive, Euler Motors, Euler ev price",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Euler",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Euler",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Euler Electric Auto Price in India 2026 | Euler ev Price",
  },
  {
    property: "og:description",
    content:
      "Euler 3 wheeler price in India starts at ₹3.10–₹9.35 Lakh. Explore Euler Motors EV specs, range, images, reviews & on-road electric auto prices for all models.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Euler 3 wheeler price in India starts at ₹3.10–₹9.35 Lakh. Explore Euler Motors EV specs, range, images, reviews & on-road electric auto prices for all models.",
  },
  {
    name: "twitter:title",
    content: "Euler Electric Auto Price in India 2026 | Euler ev Price",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Euler",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Euler";

export const H1_HEADING = "Euler EV: Powering the Future of Last-Mile Logistics";

export const ATF_CONTENT = {
  text: [
    "A high-performance Euler electric 3 wheeler is the need of the hour to scale up your business. Euler Motors has redefined the Euler electric commercial vehicle segment with industry-leading payload capacity and range. At Turno, we bring you the latest Euler motors price list, exclusive Turno Euler offers, and seamless financing to help you own the road. Whether you are searching for an Euler hiload ev showroom near me or comparing the latest Euler EV price, we provide the most transparent deals in India with a lot of supporting offers to ensure scale and profitability.",
    "To help you choose the right Euler electric 3 wheeler for your business needs, here is a detailed comparison of the latest models available at Turno. From the versatile HiLoad series to the powerful Storm EV, you can find the perfect Euler EV price and performance balance for your business requirements.",
  ],
};

export const ATF_NOTE =
  "Note: Prices are ex-showroom and may vary. On-road price depends on RTO, insurance, and state subsidies.";

export const ATF_TABLE_HEADING = "Euler Motors Price List in India 2026";

export const ATF_TABLE_COLUMNS = [
  { key: "model", label: "Euler Electric 3 Wheeler Model" },
  { key: "payload", label: "Payload (kg)" },
  { key: "topSpeed", label: "Top Speed" },
  { key: "range", label: "Max Range" },
  { key: "price", label: "Price Range (Ex-showroom)" },
];

export const ATF_TABLE_DATA = [
  { model: "Euler HiLoad DV 130 Cu. Ft", payload: "688 kg", topSpeed: "45 kmph", range: "120 km", price: "₹ 4.14 Lakh", link: "/electric-commercial-vehicles/Euler/HiLoadDV" },
  { model: "Euler HiLoad DV 170 Cu. Ft", payload: "688 kg", topSpeed: "45 kmph", range: "120 km", price: "₹ 4.51 Lakh", link: "/electric-commercial-vehicles/Euler/HiLoadDV170" },
  { model: "Euler HiLoad PV", payload: "688 kg", topSpeed: "45 kmph", range: "120 km", price: "₹ 4.14 Lakh", link: "/electric-commercial-vehicles/Euler/HiLoadPV" },
  { model: "Euler Storm EV", payload: "1250 kg", topSpeed: "70 kmph", range: "140 km", price: "₹ 9.10 Lakh", link: "/electric-commercial-vehicles/4w/Euler/Storm-Ev" },
];

export const SEO_FOOTER_CONTENT = [
  {
    heading: "About Euler EV Vehicles",
    paragraphs: [
      "Euler Motors is a pioneer in the Indian Euler electric commercial vehicle space, and the brand focuses on solving last-mile logistics challenges. The company has been established with a vision to accelerate the transition to sustainable mobility. Euler Hiload EV has been engineered to be India's most powerful electric cargo three-wheeler. Therefore, when the indigenous technology is combined with a rugged design, Euler Motors is able to provide a reliable solution for e-commerce, FMCG, and waste management sectors. When you search for an Euler EV dealership near me, you are looking for a brand that guarantees 30% higher earnings than traditional vehicles in the market.",
    ],
  },
  {
    heading: "Euler Cargo Electric Autos",
    list: [
      {
        label: "Euler HiLoad 130 Cu Ft",
        text: "Price: ₹ 4.14 Lakh. Features: 12.4 kWh liquid-cooled battery, 688 kg payload capacity, 120 km range, and 50 km charge in just 15 minutes.",
      },
      {
        label: "Euler HiLoad 170 Cu Ft",
        text: "Price: ₹ 4.51 Lakh. Features: 12.4 kWh liquid-cooled battery, 688 kg payload capacity, 120 km range, 50 km charge in just 15 minutes, and 30% more cargo space.",
      },
    ],
  },
  {
    heading: "Euler Electric Tempo Insights",
    list: [
      {
        label: "Industry-First Liquid Cooling",
        text: "The Euler hiload ev is the only vehicle in its segment with a liquid-cooled battery pack, which has high thermal stability and prevents overheating in Indian summers.",
      },
      {
        label: "Unmatched Payload",
        text: "Euler tempo outclasses every other electric three-wheeler in the cargo segment with a certified payload capacity of about 700 kg.",
      },
      {
        label: "Rapid Charging",
        text: "Euler electric auto can stay on the road for longer with fast charging of up to 50km of range in just 15 minutes of charging.",
      },
      {
        label: "Smart Connectivity",
        text: "Every Euler EV is integrated with the Euler Shepherd app. This app allows fleet management and allows for monitoring vehicle location, battery life, and charging status remotely.",
      },
    ],
  },
];

export const CTA_TEXT = "Get On Road Price";

export const FAQ_HEADING = "FAQs on Euler Electric Auto";

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Euler" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Euler",
      item: VEHICLE_LINK,
    },
  ],
};